<template>
  <div class="citation_entry" id="cite">
    <template v-if="short_bool" variant="dark">
      <span class="font-weight-bold">
        {{year}}.
      </span>
        {{title}}
      <a :href="`https://doi.org/${doi}`" target="_blank">(DOI:{{doi}})</a>
      <span class="mx-3" v-if="url">
        <a :href="url" target="_blank"> {{ url_description || "External link to article" }}</a>
      </span>
    </template>
    <template v-else> 
    <b-table-simple hover small caption-top responsive>
      <b-tr v-if="title">
        <b-th>title</b-th>
        <b-td>{{title}}</b-td>
      </b-tr> 
      <b-tr v-if="doi">
        <b-th>DOI</b-th>
        <b-td><a :href="`https://doi.org/${doi}`" target="_blank"> {{doi}} </a></b-td>
      </b-tr>  
      <b-tr v-if="url && url_description">
        <b-th>Article URL</b-th>
        <b-td><a :href="url" target="_blank"> external link </a></b-td>
      </b-tr>   
    </b-table-simple>      
    </template>
  </div>
</template>

<script>
export default {
  name: "Citation",
  props: {
    short_bool: Boolean,
    year: Number,
    title: String,
    pages: String,
    doi: String,
    url: String,
    url_description: String,
    authors: String,
    details: String,
    xml_file: String,
    json_file: String
  },

  data() {
    return {
      selectedSchema: "Articles",
    };
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #000000 !important;
}
</style>
